
import FalconAd from '~/components/common/widget/FalconAd.vue'

export default {
    name: "index-top-falcon",
    components: {
        FalconAd
    }
}
